import { useState } from "react";
import errorHandler from "../../utils/ErrorHandler";
import appApi from "../../utils/AppApi";
import { useDispatch, useSelector } from "react-redux";
import {
  setAllQuestions,
  setMaxAnswer,
  setQuiz,
  setTicket,
  setfinalizeQuiz,
} from "../../redux/actions/Quiz";
import { useNavigate } from "react-router";
import toast from "react-hot-toast";

export default function useMathcActions() {
  const [aciveQuizId, setAciveQuizId] = useState("");
  const [matchTitle, setmatchTitle] = useState("مسابقه");
  const [matchDsc, setMatchDsc] = useState("");
  const [matchLogo, setMatchLogo] = useState("");
  const [questionStatus, setQuestionStatus] = useState(null);
  const [answeredQuestions, setAnsweredQuestionsCount] = useState(0);
  const [question, setQuestion] = useState(null);

  const [selectedAnswer, setselectedAnswer] = useState("");
  const [descriptiveAnswer, setDescriptiveAnswer] = useState("");
  const [QuestionLoading, setQuestionLoading] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [submited, setSubmited] = useState(false);

  const { answeredQuestionsCount, max_answer } = useSelector(
    ({ quiz }) => quiz
  );

  const dispatch = useDispatch();
  let navigate = useNavigate();

  const getMatchId = async () => {
    try {
      await appApi.get(`/quiz/getActiveQuizId`).then(({ data }) => {
        setAciveQuizId(data.activeQuizId);
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const getQuizData = async (id) => {
    try {
      await appApi.get(`/quiz/getsingle/${id}`).then(({ data }) => {
        setmatchTitle(data.quiz.title);
        setMatchDsc(data.quiz.description);
        setMatchLogo(data.quiz.logo);
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const start = async (aciveQuizId) => {
    try {
      await appApi
        .post(`/quizTicket/create`, {
          quizId: aciveQuizId,
        })
        .then(({ data }) => {
          if (data.quizTicket !== undefined) {
            dispatch(setTicket(data.quizTicket));
            localStorage.removeItem("Ticket");
            localStorage.setItem("Ticket", data.quizTicket._id);
            navigate(`/questions/${aciveQuizId}`, { replace: true });
          }
        });
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleEndQuiz = () => {
    localStorage.removeItem("Ticket");
    dispatch(setfinalizeQuiz(true));
  };

  const checkTicket = () => {
    const Ticket = localStorage.getItem("Ticket");
    if (!Ticket) {
      navigate("/leaderBoard", { replace: true });
    }
  };

  const getQuizMaxAnswer = async (id) => {
    try {
      await appApi.get(`/quiz/getsingle/${id}`).then(({ data }) => {
        dispatch(setMaxAnswer(data.quiz.maxAnswer));
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getAllQuizData = async () => {
    const id = localStorage.getItem("Ticket");
    try {
      await appApi.get(`/quiz/takeQuiz/${id}`).then(({ data }) => {
        dispatch(setQuiz(data.quiz));
        dispatch(setAllQuestions(data.quiz.commonQuestions));
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  async function checkQuestionStatus(id) {
    try {
      await appApi.get(`/quizanswer/get/${id}`).then(({ data }) => {
        if (data.quizAnswer) {
          if (data.quizAnswer.rightAnswer === true) {
            setQuestionStatus("true");
          } else {
            setQuestionStatus("false");
          }
        } else {
          setQuestionStatus("unAnswered");
        }
      });
    } catch (error) {
      errorHandler(error);
    }
  }

  const answerQuestion = (id, questionStatus) => {
    if (questionStatus === "unAnswered") {
      if (answeredQuestionsCount < max_answer) {
        navigate(`/question/${id}`);
      }
      if (answeredQuestionsCount === max_answer) {
        toast.error("دیگر نمیتوانید به سوالی پاسخ دهید ");
      }
    }
  };

  const getQuizCount = (quiz) => {
    let count = 0;
    count = quiz.commonQuestions.length;

    if (count !== 0) {
      let AllQuestions = [...quiz.commonQuestions];
      AllQuestions.forEach((question) => checkStatus(question._id));
    }
  };

  async function checkStatus(id) {
    try {
      await appApi.get(`/quizanswer/get/${id}`).then(({ data }) => {
        if (data.quizAnswer) {
          setAnsweredQuestionsCount((prev) => prev + 1);
        } else {
          return;
        }
      });
    } catch (error) {
      errorHandler(error);
    }
  }

  const getQuestion = async (id) => {
    try {
      await appApi.get(`/quizQuestion/getsingle/${id}`).then(({ data }) => {
        setQuestion(data.quizQuestion);
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleSubmitDescriptiveQuestion = async (id) => {
    if (!descriptiveAnswer) {
      toast.error("سوال نمی تواند بی پاسخ باشد");
    } else {
      try {
        setQuestionLoading(true);
        await appApi
          .post(`/quizanswer/create`, {
            questionId: id,
            userDescriptiveAnswer: descriptiveAnswer,
          })
          .then(() => {
            setQuestionLoading(false);
            setShowConfetti(true);
            setSubmited(true);
          });
      } catch (error) {
        setQuestionLoading(false);
        errorHandler(error);
      }
    }
  };

  const handleSubmitQuestion = async (id) => {
    if (selectedAnswer !== "") {
      try {
        setQuestionLoading(true);
        await appApi
          .post(`/quizanswer/create`, {
            questionId: id,
            userOptionAnswer: selectedAnswer,
          })
          .then(({ data }) => {
            setQuestionLoading(false);
            if (data.quizAnswer.questionAnswer === selectedAnswer) {
              setShowConfetti(true);
              setSubmited(true);
            } else {
              setSubmited(true);
            }
          });
      } catch (error) {
        setQuestionLoading(false);
        errorHandler(error);
      }
    } else {
      toast.error("لطفا یکی از موارد را انتخاب کنید");
    }
  };

  const setLastQuestion = async (ticketId, questionId) => {
    try {
      await appApi.post(`/quizTicket/setlastquestion/${ticketId}`, {
        lastQuestionId: questionId,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return {
    getMatchId,
    aciveQuizId,
    setAciveQuizId,
    getQuizData,
    matchTitle,
    matchDsc,
    matchLogo,
    start,
    handleEndQuiz,
    checkTicket,
    getQuizMaxAnswer,
    getAllQuizData,
    questionStatus,
    checkStatus,
    checkQuestionStatus,
    answerQuestion,
    getQuizCount,
    setAnsweredQuestionsCount,
    answeredQuestions,
    question,
    getQuestion,
    handleSubmitDescriptiveQuestion,
    handleSubmitQuestion,
    selectedAnswer,
    setselectedAnswer,
    descriptiveAnswer,
    setDescriptiveAnswer,
    QuestionLoading,
    showConfetti,
    submited,
    setLastQuestion,
  };
}
